import React, { useEffect } from 'react';
import styles from './procedimentos_draericaferrari.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const procedimentos = [
    { titulo: 'Bioestimulador', imagem: require('./src/BIOESTIMULADOR.png') },
    { titulo: 'Harmonização Full Face', imagem: require('./src/HARMONIZACAO_FULL_FACE.png') },
    { titulo: 'Preenchimento Labial', imagem: require('./src/PREENCHIMENTO_LABIAL.png') },
    { titulo: 'Preenchimento de Olheiras', imagem: require('./src/PREENCHIMENTO_OLHEIRA.png') },
    { titulo: 'Rinomodelação', imagem: require('./src/RINOMODELACAO.png') },
    { titulo: 'Ultraformer', imagem: require('./src/ULTRAFORMER.png') },
];

const Procedimentos_draericaferrari: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.procedimentos_draericaferrari}>
            <div className={styles.header}>
                <Link to="/draericaferrari" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h2>Procedimentos</h2>
            </div>
            <div className={styles.grid}>
                {procedimentos.map((item, index) => (
                    <div className={styles.card} key={index}>
                        <img src={item.imagem} alt={item.titulo} />
                        <h3>{item.titulo}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Procedimentos_draericaferrari;
